import { useCallback } from 'react';
import { useQuery } from 'react-query';
import { CustomerPortalApi } from 'api/customer-portal/api';
import { CustomerPortalWidget } from 'api/customer-portal/types';

export const useGetCpRenderInput = ({
  enabled,
  defaultData,
  projectId,
  runtimeConfig,
  ...widget
}: CustomerPortalWidget & {
  enabled?: boolean;
  defaultData?: boolean;
  projectId: number;
  runtimeConfig?: Record<string, unknown>;
}) => {
  const mutation = useCallback(async () => {
    const payload = {
      input: widget?.widgetDefinition?.input,
      widgetType: widget?.widgetType,
      widgetVariantType: widget?.widgetVariantType,
      runtimeConfig,
      projectId,
    };

    if (defaultData) {
      const defaultResp = await CustomerPortalApi.getDefaultBuildAndRenderInput(
        payload,
      );

      return Promise.resolve(defaultResp?.renderInput);
    }

    return CustomerPortalApi.getRenderInput(payload);
  }, [
    defaultData,
    projectId,
    runtimeConfig,
    widget?.widgetDefinition?.input,
    widget?.widgetType,
    widget?.widgetVariantType,
  ]);

  return useQuery(
    [
      'cp-render-input',
      widget.widgetDefinition,
      widget.widgetType,
      widget?.widgetVariantType,
      projectId,
    ],
    mutation,
  );
};
